export enum IndicatorTypes {
  Freigabe,
  Doctype,
  Fines,
  VehicleRequests,
  Orders,
  LeasingContracts,
  CashAdvance,
  Exports,
  YourQuestion
}

export interface GetIndicatorsData {
  types: IndicatorTypes[];
}
